export const FREE_TRIAL_LINK_BUTTON_TEXT = 'Start your free trial';
export const FREE_TRIAL_SIGN_UP_LINK_BUTTON_TEXT = 'Sign Up Today';
